import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgDislike = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.00082 15C5.61916 15 5.24101 14.9272 4.88665 14.7854C3.3483 14.1701 2.60005 12.4242 3.21539 10.8858L5.61539 4.88583C6.07098 3.74685 7.1741 3 8.40082 3H16.0468C17.7036 3 19.0468 4.34315 19.0468 6V13.1716C19.0468 13.9672 18.7307 14.7303 18.1681 15.2929L13.461 20H12.5791C12.0354 20 11.5019 19.8522 11.0356 19.5725C9.61491 18.72 9.15421 16.8773 10.0067 15.4565L10.2806 15H6.00082ZM16.7539 13.8787C16.9414 13.6911 17.0468 13.4368 17.0468 13.1716V6C17.0468 5.44772 16.599 5 16.0468 5H8.40082C7.99191 5 7.62421 5.24895 7.47234 5.62861L5.07234 11.6286C4.86723 12.1414 5.11665 12.7234 5.62943 12.9285C5.74755 12.9757 5.8736 13 6.00082 13H13.8129L11.7216 16.4855C11.4375 16.9591 11.5911 17.5733 12.0646 17.8575C12.2201 17.9507 12.3979 18 12.5791 18H12.6325L16.7539 13.8787Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgDislike);

export default ForwardRef;
